import { createUseStyles } from 'react-jss'
import { colors } from '../../../variables.style'

export const style = {
  highlightBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    border: `2px solid ${colors.brandAccent}`,
    pointerEvents: 'none'
  },
  highlightBorderHeader: {
    extend: 'highlightBorder',
    border: `2px solid ${colors.brandPrimary}`
  }
}

export const useStyles = createUseStyles(style)
